import View from './View.js';
import previewView from './previewView.js';
import { icons } from '../../img/icons.svg';

class bookmarksView extends View{
    _parentEl = document.querySelector('.bookmarks__list');
    _errorMes = 'No bookmarks yet was found for you';
    _message ='';
    addHandlerRender(handler){
        window.addEventListener('load', handler)
    }
    _generateMarkup(){
        return this._data.map(bookmark => previewView.render(bookmark, false)).join('')
    }   
}

export default new bookmarksView();